export class PostMessageRequest {
    public messageTitle: string; 
    public messageContent: string;
    public listIdHealthUnit: number[];
    public listIdProfession: number[];
}